import UserProfile from "@app/screens/UserProfile/UserProfile";

export const baseUrlConfig = {
  development: 'https://api.staging.voltmoney.in',
  production: 'https://api.voltmoney.in',
  testing: 'https://api.testing.voltmoney.in',
};
console.log('ENVIROMENT', process.env.NODE_ENV);
export const baseUrl = baseUrlConfig['development'];

export const endpoints = {
  refreshToken: '/api/client/refresh/token',
  getAuthToken: '/api/client/las/customer/getAuthToken',
  generateLoginOTP: '/api/client/auth/requestOtp/v2',
  verifyLoginOTP: '/api/client/auth/verifyOtp/',
  requestEmailOTP: '/api/client/auth/requestOtp/email',
  verifyEmailOTP: '/api/client/auth/verifyOtp/email',
  userInfo: '/app/borrower/user',
  userProfile : '/app/borrower/userProfile/',
  pledgeData: '/app/borrower/application/asset/pledge/details/',
  accountAttributes: '/app/borrower/accountAttributes/',
  verifyPan: '/app/borrower/application/kyc/pan/panVerify',
  resetPan: '/app/borrower/application/kyc/pan/panReset/',
  showEnableLimit: '/app/borrower/application/enable/edit/limit/',
  editLimitRoute: '/app/borrower/application/edit/limit/',
  platformDetailsApi: '/app/pf/details/',
  getLenderInfo: '/app/borrower/application/creditApplication/lender/info/',
  logout: '/api/client/logout',
  registerOrUpdateFCMToken: '/app/device/details/registerOrUpdateToken',

  // LMS
  creditInfo:'/app/borrower/lms/credit/',
  checkWithdraw:'/app/borrower/lms/disbursal/requestDetails',
  transactionHistory: '/app/borrower/lms/transactions/history/',
  interestDetails:'/app/borrower/lms/interestCollection/details/',
  pendingRequests:'/app/borrower/lms/getPendingCreditRequestsByCreditId/',
  transactionEmail:'/app/borrower/lms/transactions/email/',
  pdfHoldingStatement : '/app/borrower/lms/holdingStatement/email/',
  requestWithdrwalOtp:'/app/borrower/lms/disbursal/v2/',
  verifyWithdrawlOtp:'/app/borrower/lms/disbursal/verifyOTP',
  bankTransferDetails:'/app/borrower/lms/repaymentBankAccountsDetails/',
  disbursalDetails:'/app/borrower/lms/disbursal/credit/',
  forclosureDetails:'/app/borrower/lms/credit/foreclosure/',
  checkForClosureStatus:'/app/borrower/lms/credit/foreclosure/requests/inprogress/',
  shortFallDetails:'/app/borrower/shortfall/data/',
  tataPayment:'/app/borrower/application/tata/merger/enabled/',
  paymentInit:'/app/borrower/lms/collection/new',
  paymentPolling:'/app/borrower/lms/collection/',
  pleadgeList:'/app/borrower/lms/collateralDetails/',
  enhanceLimit : '/app/borrower/creditModification/',
  getForeclosureDetails : '/app/borrower/lms/foreclosure/',
  requestAccVerifyOtp:'/user/borrower/account/accountVerify/request/otp/init/',
  accVerifyOtp:'/user/borrower/account/accountVerify/request/otp/verify',
  verifyOtpNewuserDetails: '/user/borrower/account/updateAccount/request/otp/verify',
  loanDetails:'/app/borrower/lms/credit/loanDetails/',
  updateAccOtp:'/user/borrower/account/updateAccount/request/otp/init',
  createRevocation : '/app/borrower/lms/createRevocation/otp/',
  verifyRevocation : '/app/borrower/lms/createRevocation/verifyOTP',
  pledgeHistory : '/app/borrower/lms/getAllCreditRequestsByCreditId/',
  renewalBreakUp: '/app/borrower/application/renewal/chargesDetails/',
  creditModification: '/app/borrower/creditModification/',
  renewalSummary:'/app/borrower/application/offer/selection/init/',
  failedRequests:'/app/borrower/lms/getFailedCreditRequestsByCreditId/',
  renewAppliction:'/app/borrower/application/',
  getOfferSelectionInit:'/app/borrower/application/offer/selection/verify/',
  dspPaymentCallback: '/app/borrower/lms/collection/deep/',
  paymentCallback: '/app/borrower/lms/collection/',
  pledgeDetails : '/app/borrower/application/asset/pledge/details/',
  manageLimitConfig : '/app/borrower/lms/credit/lender/manageLimitConfig/',
  bookTransfer : '/app/borrower/bookTransfer/allowed/',
  switchCredit : '/app/borrower/switchCredit',
  getRevocationList : '/app/borrower/lms/getRevocationByCreditId/status/',
  foreclosureValidationAndDetails: `/app/borrower/lms/foreclosure/validationAndDetails/`,
  initiateForeclosure: `/app/borrower/lms/foreclosure/otp/init/v2`,
  verifyForeclosure : `/app/borrower/lms/foreclosure/otp/verify/v2`,
  cancelForeclosure : `/app/borrower/lms/cancel/foreclosure/request/`,
  getPendingDetailsRequest: '/user/borrower/account/updateAccount/request/borrowerAccount/',
  getForeclosureCompleted: `/app/borrower/lms/foreclosure/details/foreclosure/request/account/latest/`,
  reopenAccount: '/app/borrower/lms/reopen/closed/account/',
  accountOpenInfo:'/app/borrower/lms/disbursal/minAmount/details',
  checkFrozenStatus : `/app/borrower/lms/creditAssetMapping/revocation/validationAndDetails/`,
  isPendingDisbursal: `/app/borrower/lms/credit/disbursal/pending/`,
};


export const amplitudeConfig = {
  STAGING: '0db77c455f0b7518a30b95598a6e5e5b',
  TEST_STAGING: '0db77c455f0b7518a30b95598a6e5e5b',
  QA_STAGING: '0db77c455f0b7518a30b95598a6e5e5b',
  BORROWER_PRODUCTION: 'f15bbbe2415bf57272c15694aa4358ec',
}
